<div class="warp flex-direction-revers-by-dir-he" [ngClass]="{ modular: modularId }">
  <div class="warp-autocomplete">
    <!-- <div class="select"> -->
    <div class="options-display" #trigger>
      <div
        class="select pointer"
        (click)="openSelect()"
        [ngClass]="{'open-select':isSelectOpen}"
      >
      <svg-icon svgClass="svg-img arrow" src="/assets/images/display-question/drop-down.svg" ></svg-icon>
      <div *ngIf="answerForm.controls.dialCode.value">{{ answerForm.controls.dialCode.value }}</div>

      </div>
    </div>

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayHasBackdrop]="true"
      [cdkConnectedOverlayOpen]="true"
      cdkConnectedOverlayBackdropClass="backdrop-selection"
      (backdropClick)="closeSelect()"
      [cdkConnectedOverlayOpen]="isSelectOpen"
      [cdkConnectedOverlayPositions]="positonArea"
    >
      <div class="overlay-warp">
        <div class="input-with-image">
          <img class="search" src="/assets/images/cards/search.svg" />
          <input
            class="row center"
            [placeholder]="'search.searchSmartQuestions' | translate"
            [formControl]="searchControl"
            (input)="onInputSelect($event)"
          />
        </div>
        <div class="warpper">
        <div
          *ngFor="let op of filteredOptions$ | async"
          class="item" [ngClass]="{'selected':op.dialCode==answerForm.controls.dialCode.value}"
          (click)="isDisableSignal$()?null:updateSelection(op)"
        >{{ op.dialCode}}
        </div></div>
      </div>
    </ng-template>
  
    <!-- <img src="/assets/images/display-question/israel.svg"> -->
    <!-- </div> -->
  </div>

  <div class="input-number">
    <input
      [formControl]="answerForm.controls.answer"
      (input)="onInput($event)"
      #inputElement
    />
  </div>


  <!-- <div class="warp-number">
    <p class="area-code">+972</p>
    <input
      [formControl]="answer"
      placeholder="99- 9999999"
      (input)="onInput($event)"
      #inputElement
    />
  </div> -->
</div>
